import { render, staticRenderFns } from "./partInfo.vue?vue&type=template&id=30bf9c65&scoped=true"
import script from "./partInfo.vue?vue&type=script&lang=js"
export * from "./partInfo.vue?vue&type=script&lang=js"
import style0 from "./partInfo.vue?vue&type=style&index=0&id=30bf9c65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bf9c65",
  null
  
)

export default component.exports